import url            from '../utils/url.js'
import BorderDrawer   from '../utils/map/BorderDrawer.js'
import 'leaflet-contextmenu'
import L              from 'leaflet'
import { TILE_LAYER } from '@/config/map'

export default {
  data () {
    this.map = null
    return {
      q: ''
    }
  },
  computed: {
    mapBorders () {
      return []
    },
    mapBringTo () {
      return this.$store.getters.mapBringTo
    },
    updateMapStatus () {
      return this.$store.getters.updateMapStatus
    },
    contextmenu () {
      return true
    },
    contextmenuOpened () {
      return true
    }
  },
  mounted () {
    this.initMap()
    this.drawTiles()
    this.drawBorders()
  },
  methods: {
    getMapPolygon () {
      return []
    },
    getPreferCanvas () {
      return true
    },
    async initMap () {
      this.map = L.map(this.$refs.map, {
        center: this.getMapConfig('center'),
        zoom: this.getMapConfig('zoom'),
        zoomAnimation: false,
        minZoom: this.getMapConfig('minZoom'),
        // needed for marker cluster group
        maxZoom: 18,
        contextmenu: true,
        preferCanvas: this.getPreferCanvas(),
        contextmenuWidth: 220,
        contextmenuOpened: this.contextmenuOpened,
        contextmenuItems: [{
          text: 'Что это?',
          callback: e => this.$emitter.emit('whatisit', e)
        }]
      });

      this.map.on('zoom', this.zoomHandler)
      this.map.on('moveend', this.moveendHandler)
      
      L.DomUtil.addClass(this.map._controlContainer, 'no-print')
      await this.afterMapInit().then(() => {
        this.$emitter.emit('mapInit')
      })
    },
    drawTiles () {
      L.tileLayer(TILE_LAYER).addTo(this.map)
    },
    drawBorders () {
      this.borderDrawer = new BorderDrawer(this.map, this)
      this.borderDrawer.drawAll(this.getMapPolygon(), this.mapBorders)
      this.borderDrawer.drawLocality(this.mapBorders, true)
    },
    setView (data) {
      if (this.map) {
        setTimeout(() => {
          this.map.setView([data.lat, data.lng], data.zoom)
        }, data.delay || 0)
        if (data.refreshMap) {
          this.refreshMap()
        }
      }
    },
    updateMap (data) {

    },
    setFiltersFromUrl(){
      let route = url.getRoute(this.$route)

      let prevQ = JSON.parse(JSON.stringify(this.q))
      if(route.query.q){
        this.q = route.query.q
      }else{
        this.q = ''
      }
    },
    routeHandler (newVal) {
      this.setFiltersFromUrl()
  
      this.refreshMap()
    },
    async updateRouteStateFromMap () {
      if (this.map) {
        let latlng = this.map.getCenter()
        await this.replaceRoute({
          zoom: this.map.getZoom(),
          center: [latlng.lat, latlng.lng]
        })
      }
    },
    async moveendHandler (event) {
      if (this.map) {
        let latlng = this.map.getCenter()
        await this.replaceRoute({center: [latlng.lat, latlng.lng]})
      }
    },
    async zoomHandler (event) {
      if (this.map) {
        await this.replaceRoute({zoom: this.map.getZoom()})
      }
      if (this.threadsDrawer) {
        this.threadsDrawer.redrawAll()
      }
    },
    getMapConfigData () {
      console.error('define getMapConfigData method')
    },
    getMapConfig(name){
      let usedRoute = url.getPrevOrCurrentRoute(this.$route)

      if(usedRoute.query[name]){
        // return copy of object, without listeners
        let route = usedRoute
        if(typeof route.query[name] === 'string' && route.query[name].indexOf(',') > - 1){
          return route.query[name].split(',')
        }
        return route.query[name]
      }
      return this.getMapConfigData()[name]
    },
    /* required for use in map-poup.vue */
    registerClosePopup () {
      this.replaceRoute({openedPopupInfo: null, lastEventPos: null})
    },
    /* required for use in map-poup.vue */
    registerOpenPopup (marker) {
      if (marker.options.openedPopupInfo) {
        console.log('registerOpenPopup ', marker)
        // lastEventPos - need for register correct relation popup pos
        this.replaceRoute({openedPopupInfo: marker.options.openedPopupInfo, lastEventPos: marker.options.lastEventPos})
      }
    },
    destroyMap () {
      console.log('destroyed')
      if(this.map !== null) {
        this.map.remove()
        this.map = null
      }
    },
    destroyAsync () {
      console.log('please define destroyAsync')
    }
  },
  destroyed () {
    this.destroyMap()
    this.destroyAsync()
  },
}
